import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { ChannelConfigStepper } from './ChannelConfigStepper'

import config from '../utils/config'


export class ChatWidgetStepper extends Component {

  static propTypes = {
    channel: PropTypes.object,
    channelType: PropTypes.string.isRequired,
    fetchCredentials: PropTypes.func.isRequired,
    createChannel: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired
  }

  constructor(props,context) {
    super(props,context);

    this.handleNextStep = this.handleNextStep.bind(this);
    this.renderStep = this.renderStep.bind(this);
  }

  handleNextStep() {
    const { stepper } = this.channelConfigStepper
    const step = stepper.state.activeStep
    if (step === 1) {
      if (this.props.addingChannel) {
        this.props.fetchCredentials((response, err) => {
          if (!err) {
            var filtered = response.filter( (value) => {return value.type === 'apikey'})
            this.save(filtered[0].key)
          }
        })
      }
      else {
        this.nextStep()
      }
    }
    else if (step === 2) {
      this.nextStep()
    }
  }

  renderStep(stepJson, step) {
    if (step === 2) {

      const apikey = this.props.channel && this.props.channel.params ? this.props.channel.params.apikey : ''
      const embedCode = config.ENV === 'prod'
        ? `<script src="https://cdn.assisthub.io/widget.min.js?apikey=${apikey}"></script>`
        : `<script src="https://ah-widget-dev.firebaseapp.com/widget.min.js?apikey=${apikey}&env=dev></script>`
      return (
        <div>
          Copy and paste this snippet into your web page<br /><br />
          <code>
            <div style={{backgroundColor:'#f5f5f5'}}>{embedCode}</div>
          </code>
        </div>
      )
    }
  }

  nextStep() {
    if (this.channelConfigStepper.isLastStep()) {
      this.props.goBack()
    }
    else {
      this.channelConfigStepper.stepper.nextStep()
    }
  }

  save(apikey) {
    let newChannel = {
      enabled: true,
      params: {
        apikey: apikey
      }
    }

    this.props.createChannel(newChannel, (response, err) => {
      if (!err) {
        this.nextStep()
      }
    })
  }

  render() {
    const { channel, channelType } = this.props
    return (
      <div>
        <ChannelConfigStepper ref={(s) => this.channelConfigStepper = s} channelType={channelType} channel={channel} onBeforeNextStep={this.handleNextStep} renderStep={this.renderStep}/>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/containers/ChatWidgetStepper.js